import *as THREE from 'three'

export const parameters = 
  [{"rot":[0.000012294556710382991,-12.210728809874505,0.0000026000293974144912,null],"position":[-13.354931463464682,423.78877509854044,-502.14479328019377]},{"rot":[0.00007689806842022431,-10.768782772919248,0.00001436579777862743,null],"position":[-20.464696711732916,423.7787435855171,-469.92616977739516]},{"rot":[0.000012251844853788505,-11.446634705938749,0.00000243107608951135,null],"position":[-27.36023765772522,423.77871837178833,-437.6574803029138]},{"rot":[-0.00004569059297280023,-11.824617615955328,-0.000009361401077228855,null],"position":[-34.551845945669854,423.7787277899199,-405.45806145688766]},{"rot":[0.00002617652804606046,-11.339516398595084,0.000005146110658300504,null],"position":[-41.71342387636973,423.7787332754866,-373.2515953680355]},{"rot":[0.00003325930183864522,-12.210833218999364,0.000007033672968638559,null],"position":[-48.98327189811812,423.7787165265942,-341.0704599499992]},{"rot":[-0.0001537622679306444,-10.286766566788284,-0.000027453460399765058,null],"position":[-55.95780987347877,423.77875074943597,-308.8202666678709]},{"rot":[0.00016086473984074944,-11.523171629262677,0.00003212593617034596,null],"position":[-63.005471579709294,423.77874556180154,-275.3233310034643]},{"rot":[0.0001012236776775738,-11.25614047612038,0.000019753216923785946,null],"position":[-70.53468266298468,423.77866648904876,-240.92133387385485]},{"rot":[-0.000021320043167150223,-11.91662749574053,-0.000004401279921717576,null],"position":[-78.11400258212188,423.77864252776254,-206.84653035470308]},{"rot":[0.00009940563763713382,-10.41332781647658,0.000017961265575693178,null],"position":[-85.52912084026313,423.7786182681876,-172.28331264047455]},{"rot":[10.077196733791157,-11.98018474057232,2.112701058132275,null],"position":[-92.34520674775895,421.266695249803,-140.62005454833707]},{"rot":[28.01531567072886,-9.429551811118378,4.982877203339585,null],"position":[-97.96213801929372,412.6859205493039,-115.16919009636405]},{"rot":[48.25644289344991,-8.19865424823662,9.079743933092402,null],"position":[-102.60681016130981,395.5127538799319,-93.92828758242035]},{"rot":[72.15068231629911,-3.7986901432188795,11.613709163299779,null],"position":[-106.1667152836438,367.7389414205709,-78.7089733885307]},{"rot":[92.48956266224339,1.3354893675129886,9.981135604070836,null],"position":[-108.22806536343857,292.0122147618506,-63.37875549957238]},{"rot":[93.74818858024247,2.3382156156856597,8.599075338427554,null],"position":[-107.19082283374141,259.57254770678156,-65.1750877293115]},{"rot":[96.6602907764305,2.205862073248635,7.633807928920841,null],"position":[-105.93466233016274,227.16227398411155,-68.10278027599131]},{"rot":[111.53146421242387,3.4860189037374987,5.799799391989191,null],"position":[-104.37850791821609,197.06515782655558,-75.43559764885306]},{"rot":[128.29635807357752,5.839352760285699,4.163375552036333,null],"position":[-102.12653522331742,172.51377216715562,-88.15004152192773]},{"rot":[145.16973971524868,5.580063938803051,2.004739512858604,null],"position":[-99.39852240803295,155.4684663932203,-105.62595110320838]},{"rot":[166.49457412971458,7.761330926105242,1.4127897413981059,null],"position":[-96.103347736253,146.5801367600873,-127.52174235908161]},{"rot":[-177.69616533315093,5.662754915759776,-0.6939079037670416,null],"position":[-93.46054284763673,144.67716415333643,-151.20620764875719]},{"rot":[-178.9641367012307,3.1310919256828758,-1.055601444190633,null],"position":[-91.59357767948194,145.44029207825204,-176.06256747331176]},{"rot":[176.79898233413473,1.1508632700670525,-1.5701365793094322,null],"position":[-90.63094008366674,144.78469534282425,-204.26443105737755]},{"rot":[-177.7713949217603,-0.7255536694786037,0.0234182599656963,null],"position":[-90.56650148215247,144.55109669977213,-235.01366161084033]},{"rot":[-179.42127871307275,-2.4380043130707305,0.5586375255279862,null],"position":[-91.46880514835766,145.20114679807585,-266.93882335706473]},{"rot":[176.6556209946973,-2.879159861005132,-0.17643480807546533,null],"position":[-92.91148792730097,144.42630515219892,-299.14063458303644]},{"rot":[-176.95060016079736,-3.3097240660509253,0.27561656367723253,null],"position":[-94.58435873746554,144.35231719599773,-330.5900291671589]},{"rot":[179.97084956853902,-2.4660810881700184,0.09191528571080944,null],"position":[-96.23240322184839,145.12535906918328,-362.6065433557594]},{"rot":[-179.88616969676926,-1.073926078506235,-0.16637355318232305,null],"position":[-97.28690368403235,145.16091558518184,-395.20544245301704]},{"rot":[-179.81033403866252,0.13883924371268425,-0.014118163886191233,null],"position":[-97.53913766730946,145.16191350158329,-426.5931494720642]},{"rot":[176.81031715014257,1.0909947608854818,0.1739306757326564,null],"position":[-97.14577456470681,144.42620684350484,-457.7836170243672]},{"rot":[-176.98943492434938,0.2568562245452488,-0.37406380205384576,null],"position":[-96.75210400822725,144.44343506451298,-490.00926610681995]}]
  // [{"rot":[2.1458123564514657e-7,-0.2131174218004388,4.538250385508322e-8,"XYZ"],"position":[-8.354931463464682,424.81149058082696,-502.14479328019377]},{"rot":[0.0000013421285778532407,-0.18795071581948572,2.507518230997952e-7,"XYZ"],"position":[-15.464696711732916,424.8114653650194,-469.92616977739516]},{"rot":[2.1383572487193007e-7,-0.19978146389168405,4.243369119755804e-8,"XYZ"],"position":[-22.36023765772522,424.81144015129064,-437.6574803029138]},{"rot":[-7.974539520237037e-7,-0.20637851018774284,-1.6340000120652434e-7,"XYZ"],"position":[-29.55184594566985,424.8114495694222,-405.45806145688766]},{"rot":[4.5686806757423266e-7,-0.1979118967393739,8.98238557282717e-8,"XYZ"],"position":[-36.71342387636973,424.8114550549889,-373.2515953680355]},{"rot":[5.804863285021425e-7,-0.2131192440834367,1.2277003124301853e-7,"XYZ"],"position":[-43.98327189811812,424.81143830609653,-341.0704599499992]},{"rot":[-0.0000026836656729937973,-0.17953794597452863,-4.791959140314301e-7,"XYZ"],"position":[-50.95780987347877,424.8114725289383,-308.8202666678709]},{"rot":[0.0000028076292150325365,-0.20111728520303293,5.607515524924803e-7,"XYZ"],"position":[-58.005471579709294,424.81146734130385,-275.3233310034643]},{"rot":[0.0000017666924323205082,-0.19645671237530274,3.4478855214682135e-7,"XYZ"],"position":[-65.53468266298468,424.81138826855107,-240.92133387385485]},{"rot":[-3.721062760667025e-7,-0.20798438553435877,-7.682310833307282e-8,"XYZ"],"position":[-73.11400258212188,424.81136430726485,-206.84653035470308]},{"rot":[0.0000017349612501994277,-0.18174685648702807,3.1351324231154937e-7,"XYZ"],"position":[-80.52912084026313,424.8113400476899,-172.28331264047455]},{"rot":[0.17588078307489763,-0.20909324252515657,0.036876043118266165,"XYZ"],"position":[-87.34520674775895,422.2994170293053,-140.62005454833707]},{"rot":[0.48896041687026004,-0.16457390054001494,0.08697301236280039,"XYZ"],"position":[-92.96213801929372,413.7186423288062,-115.16919009636405]},{"rot":[0.8422350318202876,-0.1430845852191013,0.15847947898251225,"XYZ"],"position":[-97.60681016130981,396.5454756594342,-93.92828758242035]},{"rot":[1.2592675361539873,-0.06627968448296874,0.20270383113150364,"XYZ"],"position":[-101.1667152836438,368.7716632000732,-78.7089733885307]},{"rot":[1.534892766648103,-0.007709939013593233,0.21298975812569992,"XYZ"],"position":[-102.53262908374191,338.3625975926571,-72.86960220621654]},{"rot":[1.5746532251409326,-0.010654405048459527,0.17276074397335217,"XYZ"],"position":[-103.17624606413625,268.46018895051685,-69.1484709735153]},{"rot":[1.575316592864505,0.00196622024846896,0.15171511544032268,"XYZ"],"position":[-103.18530043856329,237.20903368672947,-69.2771070831881]},{"rot":[1.6881753418456882,-0.003424206845076171,0.12909710725631462,"XYZ"],"position":[-103.12451083547518,207.34117731718098,-71.02438144837856]},{"rot":[1.976572723856466,0.021123282440442526,0.10250990414523077,"XYZ"],"position":[-102.82096912072666,181.83284869474667,-77.02132429775702]},{"rot":[2.261052106954866,0.03945282509327939,0.06540276618290852,"XYZ"],"position":[-101.85569116978107,161.7929183721086,-88.63041927712192]},{"rot":[2.544652463034766,0.12139595561820646,0.04087840050538814,"XYZ"],"position":[-100.37332862979059,146.4255971737001,-105.10155280318625]},{"rot":[2.9122948046081376,0.06397389164412169,0.0012957693495421541,"XYZ"],"position":[-98.98572740663244,138.04331108059475,-125.78206511548571]},{"rot":[-3.094973065254357,0.09342740008184278,-0.006124492677484359,"XYZ"],"position":[-97.01342068719296,136.0336105368861,-148.76442707676713]},{"rot":[3.084601301871808,0.0750522332773408,0.005244661887085399,"XYZ"],"position":[-94.79204543398558,136.08812265488694,-175.3814825577548]},{"rot":[-3.097706416735069,0.06005656067446597,-0.00966918832924185,"XYZ"],"position":[-92.84825207493289,136.0909680329957,-204.61640875137778]},{"rot":[3.1199258299175696,0.03963841687804691,0.003982725676371929,"XYZ"],"position":[-91.32495909805904,136.51409230992647,-234.93009315424646]},{"rot":[3.1032596728078468,0.01781225115438842,0.0074239197562740444,"XYZ"],"position":[-90.44174946624887,135.6747378464025,-265.76860025874964]},{"rot":[-3.0859435008418297,0.011917147231832027,-0.0005411143972891456,"XYZ"],"position":[-90.05653099905633,135.9293301676596,-295.93563654646755]},{"rot":[3.0778405181415143,-0.005513354987911823,0.00627448197145297,"XYZ"],"position":[-89.924041078481,136.0052294084691,-326.47442497814257]},{"rot":[-3.0858367521370003,0.0033344083219099883,-0.004218594272304723,"XYZ"],"position":[-90.05761231074983,135.92328540634153,-357.3924395250073]},{"rot":[3.13829600504059,-0.020091130961880616,0.006184927353099709,"XYZ"],"position":[-90.27327398190465,136.708539085693,-387.30614201703116]},{"rot":[3.0880862291600635,-0.0045019241259520405,-0.004323522790017853,"XYZ"],"position":[-90.6787617130004,136.03901899120515,-416.9936948994215]},{"rot":[-3.0973532605820466,0.020395905968540066,0.021281307727066358,"XYZ"],"position":[-90.38350834599679,136.02215735578653,-447.8500157167809]}]

export const planes = [
  {
    name: 'left',
    position: [-75.490, 179.043, -268.232],
    rotation: [0, 0, THREE.Math.degToRad(90)],
    width: 100,
    height: 500,
    type: 'plane'
  },
  {
    position: [-109.631, 71, -118],
    rotation: [0, 0, 0],
    width: 50,
    height: 1000,
    depth: 100,
    type: 'plane',
    name: 'bottom',
  },
  {
    position: [-16, 229, -330],
    rotation: [0, 0, 0],
    width: 100,
    height: 500,
    depth: 200,
    type: 'plane',
    name: 'full bochka',
  },
  // {
  //   position: [-77.764, 212.918, -29.134],
  //   rotation: [THREE.Math.degToRad(90), 0, 0],
  //   width: 200,
  //   height: 350,
  //   type: 'plane',
  //   name: 'bottom front ',
  // },
  {
    position: [54, 141.987, -37],
    rotation: [0, 0, 0],
    width: 100,
    height: 1100,
    depth: 300,
    type: 'plane',
    name: 'левая часть седалища',
  },
  {
    position: [-60, 237, -327],
    rotation: [0, 0, THREE.Math.degToRad(-90)],
    width: 200,
    height: 400,
    type: 'plane',
    name: 'in bochka',
  },
  {
    position: [0, 239, 109],
    rotation: [0, 0, 0],
    width: 250,
    height: 250,
    depth: 250,
    type: 'plane',
    name: 'na krishe',
  },

  {
    size: [50, 64, 64],
    type: 'sphere',
    position: [-90.604, 221.444, -155.737],
  }

  // {
  //   position: [116.104, -21, 0],
  //   rotation: [0, 0, 0],
  //   width: 1000,
  //   height: 4000,
  //   type: 'plane',
  //   name: 'ground',
  // },
  // {
  //   position: [-1267.826, -21, 0],
  //   rotation: [0, 0, 0],
  //   width: 1000,
  //   height: 4000,
  //   type: 'plane',
  //   name: 'ground',
  // },
  // {
  //   position: [-625.074, -22, -1659.145],
  //   rotation: [0, 0, 0],
  //   width: 1000,
  //   height: 2000,
  //   type: 'plane',
  //   name: 'ground',
  // },
  // {
  //   position: [-625.074, -22, 700.357],
  //   rotation: [0, 0, 0],
  //   width: 1000,
  //   height: 2000,
  //   type: 'plane',
  //   name: 'ground',
  // },

  // {
  //   position: [0, 202.531, -1120.377],
  //   rotation: [0, THREE.Math.degToRad(-22.5), 0],
  //   width: 1500.00,
  //   depth: 1000.00,
  //   height: 40,
  //   type: 'plane',
  //   name: 'от растягивания сорри мне лень на инглише  писать это',
  // },
  // {
  //   position: [0, 202.531, -1120.377],
  //   rotation: [0, THREE.Math.degToRad(22.5), 0],
  //   width: 1500.00,
  //   depth: 1000.00,
  //   height: 40,
  //   type: 'plane',
  //   name: 'от растягивания сорри мне лень на инглише  писать это',
  // },

]

export const dynamicPlanes = [
  // {
  //   position: [-40.277, 296.685, -96.999],
  //   width: 20,
  //   height: 500,
  //   depth: 500,
  //   name: 'name'
  // },
  // {
  //   position: [-40.277, 348.266, -371],
  //   width: 400,
  //   height: 2,
  //   depth: 500,
  //   rotation: [0, THREE.Math.degToRad(-13), 0],
  //   name: 'hoseholder.bottom'
  // },
  // {
  //   position: [-40.277, 500.266, -371],
  //   width: 400,
  //   height: 2,
  //   rotation: [0, THREE.Math.degToRad(-13), 0],
  //   depth: 500,
  //   name: 'hoseholder.top'
  // },
  // {
  //   position: [-48.621, 380, -311],
  //   width: 500,
  //   height: 500,
  //   depth: 1,
  //   name: 'hoseholder.middle'
  // },
  // {
  //   position: [2, 352, -362],
  //   width: 20,
  //   height: 100,
  //   depth: 500,
  //   rotation: [0, THREE.Math.degToRad(-13), 0],
  //   name: 'hoseholder.right'
  // },
  // {
  //   position: [-128, 312, -74],
  //   width: 1,
  //   height: 200,
  //   depth: 200,
  //   rotation: [0, 0, 0],
  //   name: 'hoseholder.right'
  // },
  // {
  //   position: [-70 + 80 / 2 , 312, -74],
  //   width: 80,
  //   height: 200,
  //   depth: 200,
  //   rotation: [0, 0, 0],
  //   name: 'hoseholder.left'
  // },
  // {
  //   position: [-140 - 80 / 2, 312, -74],
  //   width: 80,
  //   height: 200,
  //   depth: 200,
  //   rotation: [0, 0, 0],
  //   name: 'hoseholder.right'
  // },
  // {
  //   position: [-111.715, 245.79 - 50 / 2, -65.867],
  //   width: 50,
  //   height: 50,
  //   depth: 50,
  //   rotation: [0, 0, 0],
  //   name: 'hoseholder.сутеук'
  // },
  // size: [50000, 10, 50000], pos: [0, -10, 0], destiny: 1000, friction: 100
  // {
  //   width: 50000, 
  //   height: 500,
  //   depth: 5000,
  //   position: [0, -250, 0],
  //   density: 1000,
  //   friction: 5,
  //   move: false,
  // }
  //   {  
  //   position: [-605.649, 266.208, -50.341],
  //   rotation: [0, THREE.Math.degToRad(56), 0],
  //   width: 1500.00,
  //   height: 1000.00,
  //   depth: 40,
  //   name: 'ot.rastag',
  // },
  //   {
  //   position: [-605.649, 266.208, -50.341],
  //   rotation: [0, THREE.Math.degToRad(-56), 0],
  //   width: 1500.00,
  //   height: 1000.00,
  //   depth: 40,
  //   name: 'ot.rastag 2',
  // },
  // {
  //   position: [0, 202.531, -1120.377],
  //   rotation: [0, THREE.Math.degToRad(22.5), 0],
  //   width: 1500.00,
  //   height: 1000.00,
  //   depth: 40,
  //   name: 'ot.rastag_2',
  // },

]

export const staticBonesCount = 16
export const sameBonesCount = 11